import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { AlertService } from 'src/app/_services/alert.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { StorageService } from 'src/app/_services/storage.service';

@Component({
  selector: 'app-tfa-setup',
  templateUrl: './tfa-setup.component.html',
  styleUrls: ['./tfa-setup.component.scss']
})
export class TfaSetupComponent implements OnInit {
  username: string = '';
  qrCodeUrl: SafeUrl | null = null;
  verificationCode: string = '';
  isLoading: boolean = false;
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    private alertService: AlertService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Get username from localStorage
   // Get username from localStorage
   this.username = localStorage.getItem('tfaUsername') || '';
    
   // Check if user has a valid TFA session
   if (!this.username) {
     // No TFA username found, redirect to login
     this.alertService.errorAlert({
       title: 'Session Error',
       text: 'Please login again',
       backdrop: true
     });
     this.router.navigate(['/auth/login']);
   } else {
     // Preserve session by setting dummy token to indicate pending verification
     localStorage.setItem('tfaToken', 'pending-setup');
     
     // Check if user is trying to bypass TFA by checking localStorage
     const user = localStorage.getItem('user');
     if (user && this.storageService.isLoggedIn()) {
       // If user already has a valid session but TFA is still pending,
       // clear the session to force TFA verification
       localStorage.removeItem('user');
     }
   }
    // Load QR code
    this.loadQRCode();
  }
  
  loadQRCode(): void {
    this.isLoading = true;
    this.authService.get2FASetup(this.username).subscribe({
      next: (response: Blob) => {
        // Create a URL for the blob
        const objectURL = URL.createObjectURL(response);
        this.qrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.alertService.errorAlert({
          title: 'Error Loading QR Code',
          text: 'Please try again or contact support',
          backdrop: true
        });
        console.error('Error loading QR code:', err);
      }
    });
  }
  
  verifyCode(): void {
    if (!this.verificationCode || this.verificationCode.length !== 6) {
      this.alertService.toastWarringMessageAlertWithMessage('Please enter a valid 6-digit code');
      return;
    }
    
    this.isLoading = true;
    this.authService.verify2FACode(this.username, this.verificationCode)
        .subscribe({
            next: (response: any) => {
                this.isLoading = false;
                console.log('TFA verify response:', response);

                // Handle potential error responses
                if (response?.message || response?.success === false) {
                    this.alertService.toastWarringMessageAlertWithMessage(response.message || 'Invalid verification code');
                    return;
                }

                // At this point, verification was successful
                // Clear the pending verification flag
              // After successful verification:
localStorage.removeItem('tfaUsername');
localStorage.removeItem('tfaToken');

// Ensure we have a valid token
const authToken = this.storageService.getToken();
if (!authToken) {
  console.error('No auth token found after successful 2FA');
  this.alertService.errorAlert({
    title: 'Session Error',
    text: 'Please login again',
    backdrop: true
  });
  this.router.navigate(['/auth/login']);
  return;
}

// Force navigation to home page with full page reload if needed
this.router.navigate(['/']).then(() => {
  window.location.reload(); // Only if needed to reset app state
});
            },
            error: (error) => {
                this.isLoading = false;
                console.error('TFA verify error:', error);

                if (error.status === 401) {
                    const errorMsg = error.error?.message?.toLowerCase() || '';
                    if (errorMsg.includes('tfa') || errorMsg.includes('code')) {
                        this.alertService.toastWarringMessageAlertWithMessage('Invalid verification code');
                        return;
                    }
                    
                    // Handle other 401 cases (like expired session)
                    this.alertService.errorAlert({
                        title: 'Session Expired',
                        text: 'Your session has expired. Please login again.',
                        backdrop: true
                    });
                    this.authService.logout();
                    this.router.navigate(['/auth/login']);
                    return;
                }

                // Generic error handling
                this.alertService.errorAlert({
                    title: 'Verification Failed',
                    text: 'An error occurred during verification. Please try again.',
                    backdrop: true
                });
            }
        });
}
  
  
  
cancel(): void {
  // Clear all TFA and authentication data to ensure proper logout
  localStorage.removeItem('tfaUsername');
  localStorage.removeItem('tfaToken');
  this.authService.logout(); // Use the auth service logout to properly clear all auth data
  this.router.navigate(['/auth/login']);
}
}